import * as React from "react"
import {Helmet} from "react-helmet-async";


export default function AppFavIcon({ icon, ...props }) {
	return <Helmet>
		<link rel="icon" type="image/x-icon" href={icon} {...props} />
	</Helmet>
}